/** Viewport inset (px) on each side — keep in sync with DropdownFilter `100vw - 2*pad` if used in CSS. */
export const FILTER_POPUP_VIEWPORT_PADDING_PX = 12;

/** Minimum popup width when the anchor column is very narrow. */
export const FILTER_POPUP_MIN_WIDTH_PX = 260;

/**
 * Popup width: at least {@link FILTER_POPUP_MIN_WIDTH_PX}, at most the viewport,
 * preferring the filter column width when it falls in that range.
 */
export function clampFilterPopupWidth(anchorWidthPx) {
  const pad = FILTER_POPUP_VIEWPORT_PADDING_PX;
  const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
  const maxW = vw - 2 * pad;
  return Math.min(maxW, Math.max(FILTER_POPUP_MIN_WIDTH_PX, anchorWidthPx));
}
